import { CSSObject } from '@chakra-ui/react';

export const InfoExoticsContainer: CSSObject = {
  px: 2,
};
